w<template>
  <div class="page-chicken">
    <div class="navigation-wrapper">
    <TopNavbar></TopNavbar>
      <navbar />
      <AlertBox></AlertBox>
      </div>
      <Header :background_image="backgroundImage">
          <template 
            v-slot:title>
              SLOVENSKI PIŠČANEC
          </template>
          <template 
            v-slot:subtitle>
              vsak dan, za vse okuse
          </template>
      </Header>
      <DeliveryBanner></DeliveryBanner>

<div class="intro-chicken">
      <Intro>
        <template 
          v-slot:description>
            Marsikje po svetu ocvrt piščanec velja za tradicionalno hrano. Čeprav gre za preprosto sestavino, pa
smo pri nas njegovo pripravo, zavoljo odličnosti, malenkost zakomplicirali. Najraje imamo ocvrtega in
takšnega smo si tudi zamislili. Sočnega, a hrustljavega! Prepričani smo namreč, da je ocvrt piščanec
lahko tudi kulinarični presežek! Je vsestranski, poznamo ga v različnih oblikah in ga pripravljamo vsak
po svoje, vsak s svojim skrivnim trikom, ki ga dela našega.
        Meso mariniramo in ga rahlo paniramo <strong>brez jajc in drobtin</strong> in tako ohranimo naraven okus. Za tem
ga <strong>ocvremo pod pritiskom v posebnem cvrtniku</strong>, ki preprečuje, da bi iz njega izhlapeli naravni sokovi
in da bi meso vpilo olje. Tako boste občutili okus res nečesa neprimerljivega. Že prvi ugriz pove celo
zgodbo: <strong>hrustljav, zlato rjav, sočen in manj masten</strong>
        </template>
        <template 
          v-slot:title-last>
            ...pa dober tek!
        </template>
        <template 
          v-slot:image-11>
            <img src="../assets/chickenf.jpeg">
        </template>
        <template 
          v-slot:image-1>
            Paniran brez jajc in drobtin
        </template>
        <template 
          v-slot:image-22>
            <img src="../assets/chickenf2.jpg">
        </template>
        <template 
          v-slot:image-2>
           Hrustljavo zapečen in manj masten
        </template>
        <template 
          v-slot:image-33>
            <img src="../assets/chickenf3.jpg">
        </template>
        <template 
          v-slot:image-3>
            Neprimerljivega okusa
        </template>
        
      </Intro>
      <img class="chicken-image" src="../assets/piščanec2.svg">
      </div>
      

       <Tabs :labels="this.labels" :isDelivery="false">
        <template 
          v-slot:mainTitle>
          Slovenski piščanec
        </template>
      </Tabs>
      <Guests :testimonials="testimonials" :gallery="gallery"></Guests>
      <Footer></Footer>
      <cookieConsent></cookieConsent>
  </div>
</template>

<style lang="scss">

@import '../components/variables.scss';

.page-pizzas {
    .subpage-header {
        background-image: url('../assets/pizza-header.jpg');
        margin-top:120px;
    }

    .pizzas-content {
        width:100%;
        max-width:1200px;
        margin:0 auto;
        padding: 1em;
        box-sizing: border-box;

        .pizzas-intro {
            margin:4em 0 0 0;
            line-height: 2;
            text-align: left;
            @include screen('mobile') {
              margin:2em auto;
            }
        }
    }
}
</style>

<script>
import backgroundImage from '@/assets/chicken-header.jpg'
import TopNavbar from "@/components/TopNavbar/TopNavbar"
import Navbar from "@/components/MainNavbar/Navbar"
import Header from "@/components/Header/Header"
import DeliveryBanner from "@/components/DeliveryBanner/DeliveryBanner"
import Intro from "@/components/Intro/Intro"
import Footer from "@/components/Footer/Footer"
import Guests from "@/components/Guests/Guests"
import AlertBox from "@/components/AlertBox/AlertBox"
import Tabs from "@/components/Tabs"
import cookieConsent from "@/components/cookieConsent"

export default {
  name: "Home",
  data: () => ({
    backgroundImage,
    testimonials: [
        { name: 'Andrej Š.', message: 'Najboljši ocvrt piščanec za moj okus, lepo hrustljavo zapečen brez odvečnega olja na skorji.'},
        { name: 'Meta K.', message: 'Njihov piščanec....Sanje ❤️'},
        { name: 'Meta J.', message: 'Najboljši piščanec na svetu! Pizze odlične!'}
    ],
    labels: [
            {
                label: 'Slovenski piščanec',
                id: 10
            },
            {
                label: 'Dodatki',
                id: 11
            },
        ]
  }),
  components: {
      TopNavbar,
      Navbar,
      AlertBox,
      Header,
      DeliveryBanner,
      Intro,
      Tabs,
      Guests,
      Footer,
      cookieConsent
  },
  computed: {
        meals() {
        return this.$store.getters.allMeals
        },

        gallery() {
			return this.$store.getters.allGalleryChicken
		},
	},
	mounted() {
        this.$store.dispatch("getMeals")
        this.$store.dispatch("getGalleryChicken")
	},
};
</script>

<style lang="scss" scoped>

@import '../components/variables.scss';

.subpage-header {
    font-size:1.2rem;
}

.intro-chicken {
  position:relative;
  max-width: 1400px;
    margin: 0 auto;

  .chicken-image {
    position: absolute;
    top: 2em;
    left: 0;
    opacity: .4;
    width: 380px;

    @include screen('mobile') {
                width:100%;
                top:4em;
                opacity:.2;
            }
  }
}

</style>

